import { FormattedMessage } from 'react-intl';

import { Consent } from '../types';
import { ConsentAccordion } from './ConsentAccordion';

type ConsentListProps = {
    handleDisconnectClick: (consentId: string) => void;
    consents: Consent[];
};

export const ConsentList = ({
    handleDisconnectClick,
    consents
}: ConsentListProps) => {
    if (consents.length === 0) {
        return (
            <p>
                <FormattedMessage
                    id="_.credit_card.preferences.consent_list.empty"
                    defaultMessage="No apps"
                />
            </p>
        );
    }

    return (
        <div className="flex flex-col divide-y">
            {consents.map((consent) => (
                <ConsentAccordion
                    key={consent.consent_id}
                    consent={consent}
                    handleDisconnectClick={handleDisconnectClick}
                />
            ))}
        </div>
    );
};
